import { hosts } from '@/app/config';
import { delay, http, HttpResponse } from 'msw';

export const currentUserMocked = http.get(`${hosts.userApi}/users/profile/`, async () => {
  await delay(500);

  return HttpResponse.json(currentUser);
});

const currentUser = {
  id: 16125,
  email: 'gabriel@recruitrobin.com',
  first_name: 'Gabriel',
  last_name: 'G',
  phone_number: null,
  is_staff: true,
  indeed_license: null,
  is_active: true,
  should_change_password: false,
  created_at: '2024-05-17T11:16:51.170804Z',
  updated_at: '2025-11-12T01:21:56.773606Z',
  has_tutorial: true,
  role: 'ADMIN',
  tenant: {
    id: 2512,
    name: 'ROBIN',
    code: 'ROBIN',
    payment_method: 'PAY_PER_MATCH',
    privacy_policy_link: 'www.recruitrobin.com',
  },
  expo_push_token: 'ExponentPushToken[lYciu8I5azV3oUGdyFvL-F]',
  werknl_layout: 'NEW',
  features: [
    {
      name: 'IS_SELECT_HIGH_QUALITY_JOB_MESSAGE_CLOSED',
      value: 'true',
      enabled: true,
      created_at: '2025-08-25T13:16:36.066Z',
      updated_at: '2025-08-25T13:16:36.066Z',
    },
    {
      name: 'ROBIN_JR_FOLLOW_UP',
      value: null,
      enabled: false,
      created_at: '2025-08-25T13:54:27.646Z',
      updated_at: '2025-08-25T13:54:27.646Z',
    },
    {
      name: 'ROBIN_JR_GENERATE_REACHOUT_MESSAGE',
      value: null,
      enabled: true,
      created_at: '2025-05-20T00:01:12.581Z',
      updated_at: '2025-09-19T23:11:04.830Z',
    },
    {
      name: 'SELECTED_LANGUAGE',
      value: 'en',
      enabled: true,
      created_at: '2025-07-23T18:12:17.693Z',
      updated_at: '2025-10-28T21:05:25.375Z',
    },
    {
      name: 'RJ_COMMUNICATION_HUB_DONT_SHOW_GENERATED_MESSAGE',
      value: null,
      enabled: false,
      created_at: '2025-10-27T22:38:50.806Z',
      updated_at: '2025-11-11T13:42:59.329Z',
    },
    {
      name: 'RJ_COMMUNICATION_HUB_DONT_SHOW_WHATSAPP_MESSAGE',
      value: null,
      enabled: false,
      created_at: '2025-10-27T22:38:50.806Z',
      updated_at: '2025-11-11T13:42:59.329Z',
    },
  ],
};
